const genres = ["Alternative", "Blues", "Classical", "Country", "Electronic", "Hip-Hop", "Jazz", "Pop", "Rock", "R&B", "Reggae", "World", "Other"];
const moods = ["Happy", "Sad", "Energetic", "Romantic", "Angry", "Relaxed", "Nostalgic", "Inspirational", "Funny", "Melancholic", "Mysterious", "Other"];

const genreSelector = document.getElementById('genreSelector');
const moodSelector = document.getElementById('moodSelector');
const generateButton = document.getElementById('generateButton');
const resultDiv = document.getElementById('result');
const editButton = document.getElementById('editButton');
const copyButton = document.getElementById('copyButton');
const languageSelector = document.getElementById('languageSelector');
const notificationDiv = document.getElementById('notification');

const languageMap = {
  en: 'English',
  fr: 'French',
  de: 'German',
  jp: 'Japanese',
  ko: 'Korean',
  zh: 'Mandarin',
  it: 'Italian',
  es: 'Spanish',
  ru: 'Russian',
  ar: 'Arabic',
  hi: 'Hindi',
  pt: 'Portuguese'
};

let selectedGenre = '';
let selectedMoods = [];

function createScrollSelector(container, items, isMultiSelect = false) {
  container.innerHTML = '';
  items.forEach(item => {
    const div = document.createElement('div');
    div.className = 'scroll-item';
    div.textContent = i18next.t(`option.${item}`); // translate item
    div.onclick = () => {
      if (item === 'Other') {
        handleOtherOption(div, container, items, isMultiSelect);
      } else {
        toggleSelection(div, container, isMultiSelect);
      }
    };
    container.appendChild(div);
  });
}

function toggleSelection(div, container, isMultiSelect) {
  if (isMultiSelect) {
    div.classList.toggle('selected');
  } else {
    container.querySelectorAll('.scroll-item').forEach(el => el.classList.remove('selected'));
    div.classList.add('selected');
  }
  updateSelectedItems(container, isMultiSelect);
}

function handleOtherOption(div, container, items, isMultiSelect) {
  const input = document.createElement('input');
  input.type = 'text';
  input.className = 'custom-input';
  input.placeholder = 'Type here...';

  input.onblur = () => {
    if (input.value.trim()) {
      const newGenre = input.value.trim();
      items.splice(items.length - 1, 0, newGenre);
      createScrollSelector(container, items, isMultiSelect);
      updateSelectedItems(container, isMultiSelect);
    } else {
      div.textContent = i18next.t('option.Other'); // translate 'Other'
      div.classList.remove('selected');
    }
  };

  div.textContent = '';
  div.appendChild(input);
  input.focus();
}

function updateSelectedItems(container, isMultiSelect) {
  if (isMultiSelect) {
    selectedMoods = Array.from(container.querySelectorAll('.selected')).map(el => el.textContent);
  } else {
    selectedGenre = container.querySelector('.selected')?.textContent || '';
  }
}

async function generateLyrics() {
  const inspiration = document.getElementById('inspiration').value;
  const selectedLanguageCode = i18next.language; // Get the current language code
  const selectedLanguageName = languageMap[selectedLanguageCode]; // Map to actual language name

  if (!selectedGenre) {
    showNotification(i18next.t('Please select a genre and enter your ideas'));
    return;
  }

  generateButton.disabled = true;
  generateButton.textContent = i18next.t('Generating...');
  resultDiv.innerHTML = '<div class="loader"></div>';

  try {
    const response = await fetch('https://song-lyric-gen-py-dsgfx.replit.app/generate-lyrics', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        genre: selectedGenre,
        mood: selectedMoods.join(', '),
        inspiration: inspiration,
        language: selectedLanguageName // Send the selected language name
      }),
    });

    if (response.ok) {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullLyrics = '';
      let typingIndex = 0;

      resultDiv.innerHTML = '';

      const tempElement = document.createElement('div');

      const typeNextCharacter = () => {
        if (typingIndex < fullLyrics.length) {
          tempElement.innerHTML = fullLyrics.substring(0, typingIndex + 1);
          const textContent = tempElement.textContent || tempElement.innerText;
          resultDiv.innerHTML = fullLyrics.substring(0, typingIndex + 1);
          typingIndex++;
          setTimeout(typeNextCharacter, 0);
        } else {
          editButton.style.display = 'block';
          copyButton.style.display = 'block';
        }
      };

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk.split('\n');
        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const content = line.slice(6);
            if (content === '[END]') {
              break;
            }
            fullLyrics += content;
          }
        }
        typeNextCharacter();
      }
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.error('Failed to generate lyrics:', error);
    resultDiv.innerHTML = '<span class="error-message">' + i18next.t('Failed to generate lyrics. Please try again.') + '</span>';
  } finally {
    generateButton.disabled = false;
    generateButton.textContent = i18next.t('Generate Lyrics');
  }
}

function editLyrics() {
  resultDiv.contentEditable = true;
  resultDiv.focus();
}

function copyToClipboard() {
  const textContent = resultDiv.innerText;
  const tempElement = document.createElement('textarea');
  tempElement.value = textContent;
  document.body.appendChild(tempElement);
  tempElement.select();
  document.execCommand('copy');
  document.body.removeChild(tempElement);
  showNotification(i18next.t('Lyrics copied to clipboard'));
}

function showNotification(message) {
  notificationDiv.textContent = message;
  notificationDiv.style.display = 'block';
  notificationDiv.style.opacity = 1;
  setTimeout(() => {
    notificationDiv.style.opacity = 0;
    setTimeout(() => {
      notificationDiv.style.display = 'none';
    }, 500);
  }, 3000);
}

i18next.init({
  lng: 'en',
  debug: true,
  resources: {
    en: {
      translation: {
        "title": "AI Song Lyric Generator",
        "description": "Enter your ideas, select a genre and mood, and let our AI create unique lyrics for you.",
        "generateButton": "Generate Lyrics",
        "editButton": "Edit Lyrics",
        "inspirationPlaceholder": "Enter your lyrics, ideas, direction, or inspiration",
        "option": {
          "Alternative": "Alternative",
          "Blues": "Blues",
          "Classical": "Classical",
          "Country": "Country",
          "Electronic": "Electronic",
          "Hip-Hop": "Hip-Hop",
          "Jazz": "Jazz",
          "Pop": "Pop",
          "Rock": "Rock",
          "R&B": "R&B",
          "Reggae": "Reggae",
          "World": "World",
          "Other": "Other",
          "Happy": "Happy",
          "Sad": "Sad",
          "Energetic": "Energetic",
          "Romantic": "Romantic",
          "Angry": "Angry",
          "Relaxed": "Relaxed",
          "Nostalgic": "Nostalgic",
          "Inspirational": "Inspirational",
          "Funny": "Funny",
          "Melancholic": "Melancholic",
          "Mysterious": "Mysterious"
        }
      }
    },
    fr: {
      translation: {
        "title": "Générateur de Paroles de Chanson IA",
        "description": "Entrez vos idées, sélectionnez un genre et une humeur, et laissez notre IA créer des paroles uniques pour vous.",
        "generateButton": "Générer des paroles",
        "editButton": "Modifier les paroles",
        "inspirationPlaceholder": "Entrez vos paroles, idées, direction ou inspiration",
        "option": {
          "Alternative": "Alternative",
          "Blues": "Blues",
          "Classical": "Classique",
          "Country": "Country",
          "Electronic": "Électronique",
          "Hip-Hop": "Hip-Hop",
          "Jazz": "Jazz",
          "Pop": "Pop",
          "Rock": "Rock",
          "R&B": "R&B",
          "Reggae": "Reggae",
          "World": "World",
          "Other": "Autre",
          "Happy": "Heureux",
          "Sad": "Triste",
          "Energetic": "Énergétique",
          "Romantic": "Romantique",
          "Angry": "En colère",
          "Relaxed": "Détendu",
          "Nostalgic": "Nostalgique",
          "Inspirational": "Inspirant",
          "Funny": "Drôle",
          "Melancholic": "Mélancolique",
          "Mysterious": "Mystérieux"
        }
      }
    },
    de: {
      translation: {
        "title": "KI-Liedtexterzeuger",
        "description": "Geben Sie Ihre Ideen ein, wählen Sie ein Genre und eine Stimmung aus, und lassen Sie unsere KI einzigartige Texte für Sie erstellen.",
        "generateButton": "Texte generieren",
        "editButton": "Texte bearbeiten",
        "inspirationPlaceholder": "Geben Sie Ihre Texte, Ideen, Richtung oder Inspiration ein",
        "option": {
          "Alternative": "Alternativ",
          "Blues": "Blues",
          "Classical": "Klassisch",
          "Country": "Country",
          "Electronic": "Elektronisch",
          "Hip-Hop": "Hip-Hop",
          "Jazz": "Jazz",
          "Pop": "Pop",
          "Rock": "Rock",
          "R&B": "R&B",
          "Reggae": "Reggae",
          "World": "Welt",
          "Other": "Andere",
          "Happy": "Glücklich",
          "Sad": "Traurig",
          "Energetic": "Energisch",
          "Romantic": "Romantisch",
          "Angry": "Wütend",
          "Relaxed": "Entspannt",
          "Nostalgic": "Nostalgisch",
          "Inspirational": "Inspirierend",
          "Funny": "Lustig",
          "Melancholic": "Melancholisch",
          "Mysterious": "Mysteriös"
        }
      }
},
    jp: {
      translation: {
        "title": "AI歌詞生成器",
        "description": "アイデアを入力し、ジャンルとムードを選択して、AIにユニークな歌詞を作成させましょう。",
        "generateButton": "歌詞を生成",
        "editButton": "歌詞を編集",
        "inspirationPlaceholder": "歌詞、アイデア、方向性、インスピレーションを入力",
        "option": {
          "Alternative": "オルタナティブ",
          "Blues": "ブルース",
          "Classical": "クラシカル",
          "Country": "カントリー",
          "Electronic": "エレクトロニック",
          "Hip-Hop": "ヒップホップ",
          "Jazz": "ジャズ",
          "Pop": "ポップ",
          "Rock": "ロック",
          "R&B": "R&B",
          "Reggae": "レゲエ",
          "World": "ワールド",
          "Other": "その他",
          "Happy": "幸せ",
          "Sad": "悲しい",
          "Energetic": "エネルギッシュ",
          "Romantic": "ロマンチック",
          "Angry": "怒り",
          "Relaxed": "リラックス",
          "Nostalgic": "懐かしい",
          "Inspirational": "インスピレーショナル",
          "Funny": "面白い",
          "Melancholic": "メランコリック",
          "Mysterious": "神秘的"
        }
      }
    },
    ko: {
      translation: {
        "title": "AI 노래 가사 생성기",
        "description": "아이디어를 입력하고 장르와 분위기를 선택하면 AI가 독특한 가사를 작성해드립니다.",
        "generateButton": "가사 생성",
        "editButton": "가사 편집",
        "inspirationPlaceholder": "가사, 아이디어, 방향 또는 영감을 입력하세요",
        "option": {
          "Alternative": "얼터너티브",
          "Blues": "블루스",
          "Classical": "클래식",
          "Country": "컨트리",
          "Electronic": "일렉트로닉",
          "Hip-Hop": "힙합",
          "Jazz": "재즈",
          "Pop": "팝",
          "Rock": "록",
          "R&B": "R&B",
          "Reggae": "레게",
          "World": "월드",
          "Other": "기타",
          "Happy": "행복",
          "Sad": "슬픔",
          "Energetic": "에너제틱",
          "Romantic": "로맨틱",
          "Angry": "화남",
          "Relaxed": "휴식",
          "Nostalgic": "향수",
          "Inspirational": "영감을 주는",
          "Funny": "재미있음",
          "Melancholic": "우울한",
          "Mysterious": "신비로움"
        }
      }
    },
    zh: {
      translation: {
        "title": "AI 歌词生成器",
        "description": "输入你的想法，选择一个风格和情绪，让我们的 AI 为你创作独特的歌词。",
        "generateButton": "生成歌词",
        "editButton": "编辑歌词",
        "inspirationPlaceholder": "输入你的歌词、想法、方向或灵感",
        "option": {
          "Alternative": "另类",
          "Blues": "蓝调",
          "Classical": "古典",
          "Country": "乡村",
          "Electronic": "电子",
          "Hip-Hop": "嘻哈",
          "Jazz": "爵士",
          "Pop": "流行",
          "Rock": "摇滚",
          "R&B": "R&B",
          "Reggae": "雷鬼",
          "World": "世界",
          "Other": "其他",
          "Happy": "快乐",
          "Sad": "悲伤",
          "Energetic": "充满活力",
          "Romantic": "浪漫",
          "Angry": "愤怒",
          "Relaxed": "放松",
          "Nostalgic": "怀旧",
          "Inspirational": "鼓舞人心",
          "Funny": "有趣",
          "Melancholic": "忧郁",
          "Mysterious": "神秘"
        }
      }
    },
    it: {
      translation: {
        "title": "Generatore di Testi Canzoni AI",
        "description": "Inserisci le tue idee, seleziona un genere e un umore, e lascia che la nostra AI crei testi unici per te.",
        "generateButton": "Genera Testi",
        "editButton": "Modifica Testi",
        "inspirationPlaceholder": "Inserisci i tuoi testi, idee, direzione o ispirazione",
        "option": {
          "Alternative": "Alternativo",
          "Blues": "Blues",
          "Classical": "Classico",
          "Country": "Country",
          "Electronic": "Elettronico",
          "Hip-Hop": "Hip-Hop",
          "Jazz": "Jazz",
          "Pop": "Pop",
          "Rock": "Rock",
          "R&B": "R&B",
          "Reggae": "Reggae",
          "World": "World",
          "Other": "Altro",
          "Happy": "Felice",
          "Sad": "Triste",
          "Energetic": "Energico",
          "Romantic": "Romantico",
          "Angry": "Arrabbiato",
          "Relaxed": "Rilassato",
          "Nostalgic": "Nostalgico",
          "Inspirational": "Ispiratore",
          "Funny": "Divertente",
          "Melancholic": "Malinconico",
          "Mysterious": "Misterioso"
        }
      }
    },
        // Add Spanish, Russian, Arabic, Hindi, and Portuguese translations
        es: {
          translation: {
            "title": "Generador de Letras de Canciones con IA",
            "description": "Introduce tus ideas, selecciona un género y estado de ánimo, y deja que nuestra IA cree letras únicas para ti.",
            "generateButton": "Generar Letras",
            "editButton": "Editar Letras",
            "inspirationPlaceholder": "Introduce tus letras, ideas, dirección o inspiración",
            "option": {
              "Alternative": "Alternativo",
              "Blues": "Blues",
              "Classical": "Clásico",
              "Country": "Country",
              "Electronic": "Electrónico",
              "Hip-Hop": "Hip-Hop",
              "Jazz": "Jazz",
              "Pop": "Pop",
              "Rock": "Rock",
              "R&B": "R&B",
              "Reggae": "Reggae",
              "World": "World",
              "Other": "Otro",
              "Happy": "Feliz",
              "Sad": "Triste",
              "Energetic": "Enérgico",
              "Romantic": "Romántico",
              "Angry": "Enfadado",
              "Relaxed": "Relajado",
              "Nostalgic": "Nostálgico",
              "Inspirational": "Inspirador",
              "Funny": "Divertido",
              "Melancholic": "Melancólico",
              "Mysterious": "Misterioso"
            }
          }
        },
        ru: {
          translation: {
            "title": "Генератор Песенных Текстов с ИИ",
            "description": "Введите ваши идеи, выберите жанр и настроение, и позвольте нашему ИИ создать уникальные тексты для вас.",
            "generateButton": "Генерировать Тексты",
            "editButton": "Редактировать Тексты",
            "inspirationPlaceholder": "Введите ваши тексты, идеи, направления или вдохновение",
            "option": {
              "Alternative": "Альтернатива",
              "Blues": "Блюз",
              "Classical": "Классика",
              "Country": "Кантри",
              "Electronic": "Электроника",
              "Hip-Hop": "Хип-Хоп",
              "Jazz": "Джаз",
              "Pop": "Поп",
              "Rock": "Рок",
              "R&B": "Ритм-н-блюз",
              "Reggae": "Регги",
              "World": "Мировая",
              "Other": "Другое",
              "Happy": "Счастливый",
              "Sad": "Грустный",
              "Energetic": "Энергичный",
              "Romantic": "Романтический",
              "Angry": "Злость",
              "Relaxed": "Расслабленный",
              "Nostalgic": "Ностальгический",
              "Inspirational": "Вдохновляющий",
              "Funny": "Забавный",
              "Melancholic": "Меланхоличный",
              "Mysterious": "Таинственный"
            }
          }
        },
        ar: {
          translation: {
            "title": "مولد كلمات الأغاني بالذكاء الاصطناعي",
            "description": "أدخل أفكارك، حدد النوع والحالة المزاجية، ودع الذكاء الاصطناعي ينشئ لك كلمات فريدة.",
            "generateButton": "إنشاء كلمات",
            "editButton": "تحرير الكلمات",
            "inspirationPlaceholder": "أدخل كلماتك، أفكارك، الاتجاه، أو الإلهام",
            "option": {
              "Alternative": "بديل",
              "Blues": "بلوز",
              "Classical": "كلاسيكي",
              "Country": "كانتري",
              "Electronic": "إلكتروني",
              "Hip-Hop": "هيب-هوب",
              "Jazz": "جاز",
              "Pop": "بوب",
              "Rock": "روك",
              "R&B": "آر أند بي",
              "Reggae": "ريجي",
              "World": "عالمي",
              "Other": "أخرى",
              "Happy": "سعيد",
              "Sad": "حزين",
              "Energetic": "نشيط",
              "Romantic": "رومانسي",
              "Angry": "غاضب",
              "Relaxed": "مسترخي",
              "Nostalgic": "حنين",
              "Inspirational": "ملهم",
              "Funny": "مضحك",
              "Melancholic": "كئيب",
              "Mysterious": "غامض"
            }
          }
        },
        hi: {
          translation: {
            "title": "एआई गीत गीतराइटर जनरेटर",
            "description": "अपनी विचार, शैली और मूड का चयन करें, और हमारी एआई आपके लिए अनोखी गीत लिखेगी।",
            "generateButton": "गीत उत्पन्न करें",
            "editButton": "गीत संपादित करें",
            "inspirationPlaceholder": "अपने गीत, विचार, दिशा, या प्रेरणा दर्ज करें",
            "option": {
              "Alternative": "वैकल्पिक",
              "Blues": "ब्लूज़",
              "Classical": "शास्त्रीय",
              "Country": "कंट्री",
              "Electronic": "इलेक्ट्रॉनिक",
              "Hip-Hop": "हिप-हॉप",
              "Jazz": "जैज़",
              "Pop": "पॉप",
              "Rock": "रॉक",
              "R&B": "आर एंड बी",
              "Reggae": "रेग्गी",
              "World": "दुनिया",
              "Other": "अन्य",
              "Happy": "खुश",
              "Sad": "दुखी",
              "Energetic": "ऊर्जावान",
              "Romantic": "रोमांटिक",
              "Angry": "गुस्सा",
              "Relaxed": "आरामदायक",
              "Nostalgic": "नोस्टाल्जिक",
              "Inspirational": "प्रेरणादायक",
              "Funny": "मज़ेदार",
              "Melancholic": "उदासी",
              "Mysterious": "रहस्यमय"
            }
          }
        },
        pt: {
          translation: {
            "title": "Gerador de Letras de Música com IA",
            "description": "Insira suas ideias, selecione um gênero e humor, e deixe nossa IA criar letras únicas para você.",
            "generateButton": "Gerar Letras",
            "editButton": "Editar Letras",
            "inspirationPlaceholder": "Insira suas letras, ideias, direções ou inspiração",
            "option": {
              "Alternative": "Alternativo",
              "Blues": "Blues",
              "Classical": "Clássico",
              "Country": "Country",
              "Electronic": "Eletrônico",
              "Hip-Hop": "Hip-Hop",
              "Jazz": "Jazz",
              "Pop": "Pop",
              "Rock": "Rock",
              "R&B": "R&B",
              "Reggae": "Reggae",
              "World": "World",
              "Other": "Outro",
              "Happy": "Feliz",
              "Sad": "Triste",
              "Energetic": "Energético",
              "Romantic": "Romântico",
              "Angry": "Bravo",
              "Relaxed": "Relaxado",
              "Nostalgic": "Nostálgico",
              "Inspirational": "Inspirador",
              "Funny": "Engraçado",
              "Melancholic": "Melancólico",
              "Mysterious": "Misterioso"
            }
          }
        }
      }
    }, function(err, t) {
      jqueryI18next.init(i18next, $);
      $('body').localize();
    });

languageSelector.addEventListener('change', function() {
  const selectedLanguage = this.value;
  i18next.changeLanguage(selectedLanguage, function(err, t) {
    $('body').localize();
    createScrollSelector(genreSelector, genres);
    createScrollSelector(moodSelector, moods, true);
  });
});

createScrollSelector(genreSelector, genres);
createScrollSelector(moodSelector, moods, true);